<template>
  <Head title="Login" />
  <form class="mt-1 w-full max-w-lg" @submit.prevent="login">
    <div class="py-12 px-10">
      <img class="mb-8 hidden md:block" src="/images/logo_auth.png" width="100" height="100">
      
      <template v-if="!$page.props.modal">
        <h1 class="text-3xl">Painel do profissional de saúde</h1>

        <email-input v-model="form.email" :error="form.errors.email" class="mt-10" label="E-mail" type="email" autofocus autocapitalize="off" />
        <password-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Senha" />
        <div class="w-full pt-4 flex justify-end">
          <Link class="text-xs text-primary underline text-right" href="forgot-password">
            Esqueceu a senha?
          </Link>
        </div>
        <label class="flex items-center mt-6 select-none" for="remember">
          <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
          <span class="text-sm">Permanecer conectado</span>
        </label>
        <loading-button :loading="form.processing" class="btn-primary w-full mt-6 justify-center" type="submit">Login</loading-button>
        <Link href="register">
          <button type="button" class="btn-primary-invert w-full mt-4 uppercase text-xs">Não tem um conta? Cadastre-se</button>
        </Link>
      </template>

      <template v-else-if="$page.props.modal == 'success'">
        <h2 class="text-xl font-bold lg:text-2xl">Seja muito bem-vindo à ah.life!</h2>

        <p class="text-sm lg:text-lg my-5">
          Agradecemos por se cadastrar em nossa plataforma. 
          Seu perfil está sendo analisado por nossos especialistas 
          e em breve entraremos em contato para fornecer mais 
          informações sobre os próximos passos.
        </p>

        <p class="text-sm lg:text-lg mb-6">
          Estamos ansiosos para tê-lo como parte de nossa equipe de saúde.
        </p>

        <button type="button" class="btn-primary-invert w-full mt-4 uppercase text-xs" @click="$page.props.modal = null">
          Quero fazer login
        </button>
      </template>
    </div>
  </form>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/Fields/TextInput'
import PasswordInput from '@/Shared/Fields/PasswordInput'
import EmailInput from '@/Shared/Fields/EmailInput'
import LoadingButton from '@/Shared/Components/LoadingButton'
import Layout from '@/Pages/Auth/Professional/Layout'

export default {
  layout: Layout,
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    EmailInput,
    PasswordInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: process.env.NODE_ENV !== 'production' ? 'profissional@ahlife.com.br' : '',
        password: process.env.NODE_ENV !== 'production' ? '123456' : '',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
  mounted () {
    localStorage.showWalletNotify = true;
  },
}
</script>
